import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type Conversation = MilesPosNotesIntegrationService.Components.Schemas.Conversation;

interface NotificationCenterState {
  unreadConversations: Conversation[];
  conversations: Conversation[];
}

const initialState: NotificationCenterState = {
  unreadConversations: [],
  conversations: [],
};

export const notificationCenterSlice = createSlice({
  name: 'notificationCenter',
  initialState,
  reducers: {
    setConversations(state, action: PayloadAction<Conversation[]>) {
      state.conversations = action.payload.filter((conversation) => !conversation.referenceMap?.salesQuoteId);
      state.unreadConversations = action.payload.filter(
        (conversation) =>
          ((conversation.unreadMessages && conversation.unreadMessages > 0) || !conversation.isSeenByCurrentUser) &&
          !conversation.referenceMap?.salesQuoteId
      );
    },
  },
  selectors: {
    selectUnreadConversations: (state: NotificationCenterState) => state.unreadConversations,
    selectUnreadConversationsCount: (state: NotificationCenterState) => state.unreadConversations.length,
    selectConversations: (state: NotificationCenterState) => state.conversations,
  },
});

export const { setConversations } = notificationCenterSlice.actions;

export const notificationCenterSelectors = notificationCenterSlice.selectors;
export const notificationCenterReducer = notificationCenterSlice.reducer;
